export enum ECallEventName {
    MEDIA_STATE = "mediaState",
    STATE = "state",
    LOCAL_STREAM = "localStream",
    REMOTE_STREAM = "remoteStream",
    MUTE = "mute",
    CAMERA = "camera",
    SCREEN_SHARE = "screenShare",
    TRANSCRIPTION = "transcription",
    TRANSCRIPTION_STARTED = "transcription.started",
    TRANSCRIPTION_DIALOGUE = "transcription.dialogue",
    TRANSCRIPTION_COMPLETED = "transcription.completed",
    RECORDING = "recording",
    RECORDING_STARTED = "recording.started",
    RECORDING_COMPLETED = "recording.completed",
    /** Signaling WebSocket status: { status: "reconnecting" | "reconnected" | "failed", attempt?, code? } */
    SIGNALING = "signaling",
}